import { classes } from "../../nucleo/classes";
import {
  rotuloDaVez,
  textoDoPrazo,
  type Esteira,
  type VozDaEsteira,
} from "../../nucleo/implantacoes";

/**
 * A faixa de números do topo do painel: etapas concluídas, de quem é a vez e o prazo.
 *
 * **O bloco de prazo é o ponto sensível desta tela.** Enquanto o ambiente não for liberado e o
 * kickoff não for aceito, não existe entrega prevista. Mostrar uma estimativa
 * interna como data para o cliente transformaria um número de trabalho em promessa contratual,
 * em 138 esteiras vivas. Sem data, o bloco diz o que é verdade: quantos dias foram contratados
 * e o que falta para eles começarem a contar.
 */
export function ResumoDaImplantacao({
  esteira,
  voz = "cliente",
}: {
  esteira: Esteira;
  voz?: VozDaEsteira;
}) {
  const prazo = textoDoPrazo(esteira.prazo, voz);

  return (
    <section className="painel-resumo" aria-label="Resumo da implantação">
      <div className="painel-resumo__bloco">
        <div className="painel-resumo__numero" data-testid="etapas-concluidas">
          {esteira.concluidas}
          <small>/{esteira.total}</small>
        </div>
        <div className="painel-resumo__rotulo">etapas concluídas</div>
      </div>

      <div className="painel-resumo__bloco">
        <div
          className={classes(
            "painel-resumo__numero",
            "text-[20px]",
            esteira.vez === "cliente" && "text-marca-profunda",
          )}
          data-testid="de-quem-e-a-vez"
          data-vez={esteira.vez}
        >
          {rotuloDaVez(esteira.vez, voz)}
        </div>
        <div className="painel-resumo__rotulo">de quem é a vez</div>
      </div>

      <div className="painel-prazo" data-testid="bloco-de-prazo">
        <div className="painel-resumo__rotulo mt-0 mb-2">{prazo.titulo}</div>
        <div
          className={classes(
            "painel-prazo__data",
            prazo.data === null && "painel-prazo__data--indefinida",
          )}
          data-testid="entrega-prevista"
          data-definida={prazo.data === null ? "nao" : "sim"}
        >
          {/* Sem data, a frase entra no lugar do número. Nunca um traço, nunca "0 dias": o que
              o cliente precisa saber é que o relógio ainda não começou, e por quê. */}
          {prazo.data ?? "a definir"}
        </div>
        <p className="painel-prazo__explicacao">{prazo.explicacao}</p>
      </div>
    </section>
  );
}
